import actionTypes from "./actionTypes";
import api from "./api";
export default {
    saveSummaryReport: (summaryReport) => ({
        type: actionTypes.SAVE_SUMMARY_REPORT,
        payload: {
            promise: () => api.saveSummaryReport(summaryReport)
        },
        scope: `${actionTypes.SAVE_SUMMARY_REPORT}_${summaryReport.Id}`
    }),
    setDraft: (draft) => ({
        type: actionTypes.SET_DRAFT,
        draft
    }),
    getSummaryReport: (summaryReportId) => ({
        type: actionTypes.GET_SUMMARY_REPORT,
        payload: {
            promise: () => api.getSummaryReport(summaryReportId)
        },
        scope: `${actionTypes.GET_SUMMARY_REPORT}_${summaryReportId}`
    }),
    setSummaryReportId: (summaryReportId) => ({
        type: actionTypes.SET_SUMMARY_REPORT_ID,
        summaryReportId
    }),
    setNewSummaryReport: (projectId) => ({
        type: actionTypes.SET_NEW_SUMMARY_REPORT,
        projectId
    })
};
